<script setup lang="ts">
import {
  PageFieldsFragment,
  FieldNodePageFieldSidebarWidgets,
  ParagraphAnchors,
  ParagraphStickyEventTeaser,
} from '~/api/graphql/generated'
import { Link } from '~/types'

const props = defineProps<{
  entity: PageFieldsFragment
  breadcrumbs?: Link[]
}>()
</script>

<template>
  <SectionHero :entity="entity" :breadcrumbs="breadcrumbs" />
  <SectionAnchors v-if="entity.fieldAnchors?.entity" :entity="entity.fieldAnchors.entity as ParagraphAnchors" />
  <SectionSidebar :sidebar="entity.fieldSidebarWidgets as FieldNodePageFieldSidebarWidgets[]" />
  <SectionStickyEventTeaser :entity="entity?.fieldStickyEventTeaser?.entity as ParagraphStickyEventTeaser" />
  <Sections :entity="entity" />
</template>
